module.exports = __webpack_public_path__ + "static/media/2.571792cc.JPG";